/* eslint no-restricted-globals: 0 */

import { TranslatableError } from './errors';

/**
 * Copies a value to the clipboard
 */
export const copyHtmlToClipboard = (value: string) => {
  // We cannot use navigator.clipboard because Atlassian does not support iframes with
  // flags allow="clipboard-read; clipboard-write"

  const div = document.createElement('div');
  div.innerHTML = value;
  document.body.appendChild(div);

  document.getSelection()!.selectAllChildren(div);
  const result = document.execCommand('copy');
  div.remove();

  if (!result) {
    throw new TranslatableError(
      'There was a problem copying to clipboard.',
      'snackbar-error-message.could-not-copy-to-clipboard'
    );
  }
  return result;
};
